import {formattedPropertyModel, RenderingServices} from '@wallaby-ui/core';
import {ICellRendererParams} from 'ag-grid-community';

import {I18N} from './base_link_formatter_params';
import {EncounterTypeEnum} from 'src/js/containers/encounter';
import {
  CellRendererParams,
  CELL_RENDERER_PARAMS,
  CELL_RENDERER_PARAMS_AG,
} from 'src/js/model/cell_renderer_params';

const SELECTED_TABS = {encounter: 1};

export interface BaseEncounterLinkParamsType extends ICellRendererParams {
  id: string | number;
  label: string | undefined;
  searchParams?: {selectedTabs: string};
  titleText: string | number;
  encounterType: EncounterTypeEnum;
}

export function baseDashboardEncounterLinkFormatterParams(
  params: ICellRendererParams,
  services: RenderingServices = {}
): BaseEncounterLinkParamsType {
  const {intl} = services;
  const {colDef, data, value} = params;

  const nameWithBirthNumber = `${value} (${data.patientIdentificationNumber})`;
  const formatterParams = new CellRendererParams(
    colDef?.[CELL_RENDERER_PARAMS_AG] || colDef?.[CELL_RENDERER_PARAMS] || {}
  );
  const label =
    intl &&
    formattedPropertyModel.FormattedProperty.formatLabel(
      nameWithBirthNumber,
      intl,
      data,
      formatterParams.getI18nParams()
    );

  const id = data.encounterId;
  const {encounterType} = data;
  const titleText = `${intl?.formatMessage(I18N.OPEN_DETAIL)} - ${label}`;
  const searchParams = {selectedTabs: JSON.stringify(SELECTED_TABS)};

  return {...params, label, searchParams, id, titleText, encounterType};
}
